//============================================================================
// Name        : sidebar_v2.ts
// Purpose     : Implement inventory page sidebar v2 logic
// Created     : 2021-01-21
// Author      : AliReza Mohagheghi
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import axios from "axios";
import * as QueryString from "query-string";
import {ICustomNodeOptions, SeTreeview} from "../controls/se_treeview";
import {InitPage} from "../index";

declare var inventoryUrl: string;
declare var loadCategoriesUrl: string;
declare var inventoryStatsUrl: string;
declare var inventoryCountCategories: string;

declare var inventoryFetchZones: string;
declare var inventoryFetchStatus: string;

declare var paramsObj: object;

interface IZoneStat {
    id: any;
    count: number;
}

interface IStatusStat {
    id: number;
    count: number;
}

interface IItemTypeStat {
    id: number;
    count: number;
}

interface IInventoryStats {
    total_count: number;
    item_count: number;
    excluded_skus: number;
    zones: IZoneStat[];
    status: IStatusStat[];
    item_types: IItemTypeStat[];
}

export function LoadPage() {
    InitPage("manage_exclusions", () => {
        const treeview = new SeTreeview();
        treeview.setListCounter("categories", async () => {
            // Get the url from the parent
            const resp = await axios.get(inventoryCountCategories + ".json");
            if (resp.status != 200) {
                return window.showErrorDialog("Error getting inventory stats");
            }

            const updateCounterFunc = (cats) => {
                // Update category counts
                for (const cat of cats) {
                    const el = $(".categories-list").find(`[data-record-id='${cat.id}']`).find("div");
                    el.html(` (${cat.count})`);
                    el.parent().data("count", cat.count);

                    updateCounterFunc(cat.children);
                }
                treeview.countFinished("categories");
            };
            updateCounterFunc(resp.data);
        });

        // Load and count zones
        const loadAssetCountFunc = async () => {
            (paramsObj as any).stats_count = true;
            const resp = await axios.get(inventoryStatsUrl, { params: paramsObj });
            if (resp.status != 200) {
                return window.showErrorDialog("Error getting inventory stats");
            }

            const stats: IInventoryStats = resp.data;

            // Update total asset count
            $("#totalItemInventoryCount").text(stats.excluded_skus);
        };

        // Async load all the sidebar data on a delay
        setTimeout(
            () => {
                loadAssetCountFunc().then();
                treeview.loadNodes("categories", loadCategoriesUrl + ".json")
                        .then(() => treeview.setCheckedNodes("categories"));

            },
            1000 // Initial delay before populating remaining sections
        );

        // On page load keep track of the filtering options
        const currentFilters  = QueryString.parse(location.search);
        delete currentFilters.utf8;
        let savedFiltersStr = localStorage.getItem("inventoryFilters");

        // Should restore filters
        if (Object.keys(currentFilters).length <= 2 && savedFiltersStr) {
            const savedFilters = QueryString.parse(savedFiltersStr);
            if (savedFilters.utf8) {
                delete savedFilters.utf8;
            }
            if (!currentFilters.search) {
                if (savedFilters.search) {
                    delete savedFilters.search;
                }
                if (Object.keys(currentFilters).length == Object.keys(savedFilters).length) {
                    return;
                }
            }
            else {
                if (!location.search.includes("filter")) {
                    savedFilters.search = currentFilters.search;
                    savedFilters.multilocation = currentFilters.multilocation;
                    savedFiltersStr = QueryString.stringify(savedFilters);
                }
            }
            if (!location.search.includes("antenna_id")) {
                location.search = savedFiltersStr;
            }
        }

        // Should save new filters
        delete currentFilters.search;
        delete currentFilters.multilocation;
        if (Object.keys(currentFilters).length > 1) {
            localStorage.setItem("inventoryFilters", location.search);
        }
    });

    InitPage("lightspeed", () => {

        // Handle clearing inventory filters
        $(".clear-filters").on("click", () => {
            console.log("Clearing filters");
            localStorage.removeItem("inventoryFilters");
            location.href = inventoryUrl;
        });
        window.onbeforeunload =  (e) => {
            window.onunload = () => {
                window.localStorage.removeItem("inventoryFilters");
            }
            return undefined;
        };
    });
}
